import React, { useRef, useEffect, useState } from "react";
import PageTitle from "../../../../components/partials/PageTitle";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPolicyCoverByCategory } from "../../../../redux/slice/policy/policySlice";
import SavingsSettings from "../../../../components/policy/SavingsSettings";
import SavingsAccounting from "../../../../components/policy/SavingsAccounting";
import { resetPolicyStatus } from "../../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import { getUnpaginatedCharges } from "../../../../redux/slice/charges/chargesSlice";
import SavingsInterest from "../../../../components/policy/SavingsInterest";
import SavingsCover from "../../../../components/policy/SavingsCover";
import CreditGeneralInformation from "../../../../components/policy/creditlife/CreditGeneralInformation";

const CreateCreditLifePolicy = () => {
  const { isSuccess } = useSelector((state) => state?.savingsPolicy);
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // breadcrumb
  const breadcrumb = {
    from: {
      title: "Credit Life Policies",
      link: "/admin/credit-life",
    },
    current: {
      title: "Configuration",
      link: null,
    },
  };

  const [generalInformation, setGeneralInformation] = useState(null);
  const [interest, setInterest] = useState(null);
  const [accounting, setAccounting] = useState(null);
  const [cover, setCover] = useState([]);
  const [lifeCover, setLifeCover] = useState([]);
  const [lifeCoverValues, setLifeCoverValues] = useState()
  const [policyConfig, setPolicyConfig] = useState({});

  const genInfoRef = useRef();
  const accounting1Ref = useRef();
  const interestRef = useRef();
  const coverRef = useRef();
  const policyCreateCloseRef = useRef();
  const settingsRef = useRef();

  useEffect(() => {
    setPolicyConfig({
      ...policyConfig,
      policy_savings_general: {
        ...generalInformation,
        policy_name: generalInformation?.name,
        minimum_duration: generalInformation?.minimun_duration,
      },
      ...lifeCoverValues,
      cover_type: cover,
      life_cover: lifeCover,
      policy_savings_interest: {
        default_rate: interest?.default_interest_rate,
        minimum_rate: interest?.minimum_interest_rate,
        maximum_rate: interest?.maximum_interest_rate,
        // interest_cal_type: interest?.interest_cal_type,
        // interest_posting_period: interest?.interest_posting_period,
        // interest_compound_period: interest?.interest_compound_period,
      },
      policy_savings_accounting: accounting,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalInformation, interest, accounting, cover, lifeCover, lifeCoverValues]);

  useEffect(() => {
    if (isSuccess) {
      policyCreateCloseRef.current.click();
      dispatch(resetPolicyStatus());
      navigate("/admin/savings-policy");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  useEffect(() => {
    dispatch(getPolicyCoverByCategory(2));
    dispatch(getUnpaginatedCharges());
    if (
      !user_permissions?.some(
        (permission) => permission.name === "settings module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "policy configuration module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create policy"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions, dispatch]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Policy Configuration' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card position-relative'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary '>
                    Creating Credit Life Policy
                  </h4>
                  <span
                    onClick={() => navigate(-1)}
                    className='btn btn-primary btn-sm float-end '
                  >
                    Go Back
                  </span>
                </div>
              </div>
              <div>
                <ul className='nav nav-pills bg-nav-pills nav-justified mb-3'>
                  <li className='nav-item'>
                    <a
                      href='#general_information'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link rounded-0 active border'
                      ref={genInfoRef}
                    >
                      <i className='mdi mdi-home-variant d-md-none d-block'></i>
                      <span className='d-none d-md-block'>
                        General Information
                      </span>
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='#cover'
                      data-bs-toggle='tab'
                      aria-expanded='true'
                      className='nav-link rounded-0 border'
                      ref={coverRef}
                    >
                      <i className='mdi mdi-account-circle d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Policy Cover</span>
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      href='#interest'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link rounded-0 border'
                      ref={interestRef}
                    >
                      <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Rate</span>
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      href='#accounting1'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link rounded-0 border'
                      ref={accounting1Ref}
                    >
                      <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Accounting</span>
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      href='#accounting'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link rounded-0 border'
                      ref={accountingRef}
                    >
                      <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Accounting</span>
                    </a>
                  </li> */}
                  <li className='nav-item '>
                    <a
                      href='#setting'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link rounded-0 border'
                      ref={settingsRef}
                    >
                      <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Settings</span>
                    </a>
                  </li>
                </ul>

                <div className='tab-content'>
                  <div
                    className='tab-pane show active'
                    id='general_information'
                  >
                    <CreditGeneralInformation
                      getGenerallInfo={setGeneralInformation}
                      interestRef={interestRef}
                      coverRef={coverRef}
                    />
                  </div>
                  <div className='tab-pane' id='cover'>
                    <SavingsCover
                      interestRef={interestRef}
                      genInfoRef={genInfoRef}
                      setCover={setCover}
                      setLifeCover={setLifeCover}
                      setLifeCoverValues={setLifeCoverValues}
                    />
                  </div>
                  <div className='tab-pane' id='interest'>
                    <SavingsInterest
                      coverRef={coverRef}
                      accountingRef={accounting1Ref}
                      genInfoRef={genInfoRef}
                      setInterest={setInterest}
                    />
                  </div>
                  <div className='tab-pane' id='accounting1'>
                    <SavingsAccounting
                      interestRef={interestRef}
                      settingsRef={settingsRef}
                      setAccounting={setAccounting}
                    />
                  </div>
                  {/* <div className='tab-pane' id='accounting'>
                    <SavingsAccounting
                      interestRef={interestRef}
                      settingsRef={settingsRef}
                      setAccounting={setAccounting}
                    />
                  </div> */}
                  <div className='tab-pane' id='setting'>
                    <SavingsSettings
                      accountingRef={accounting1Ref}
                      coverRef={coverRef}
                      policyConfig={policyConfig}
                      interestRef={interestRef}
                      genInfoRef={genInfoRef}
                      policyCreateCloseRef={policyCreateCloseRef}
                      // setPreview={setPreview}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateCreditLifePolicy;
